import React from 'react'

const Pencil = ({ active, ...props }) => (
  <svg width="12" height="12" viewBox="0 0 12 12" {...props}>
    <g fill={!active ? '#757575' : '#FFF'} fill-rule="evenodd">
      <path d="M.8222 8.1247l.0065.0065-.768 2.6925c-.236.8263.236 1.318 1.082 1.082l2.6787-.7818.0054.0054 5.8701-5.87-3.0045-3.0047L.8222 8.1247zM11.6168 1.677L10.2791.3395c-.4524-.4525-1.2-.4525-1.6721 0L7.4857 1.4607l3.0098 3.0098 1.1213-1.1213c.4722-.4721.4722-1.2197 0-1.6721" />
    </g>
  </svg>
)

export default Pencil
